
import { formatNumberByThousands } from '../../helpers/formatNumberByThousands';
import { ValidationResultType } from '../../hooks/useFieldValidation';
import TextInputField from '../TextInputField/TextInputField';

type MonetaryFieldProps = {
    name: string;
    label?: string;
    disabled?: boolean;
    min?: number;
    max?: number;
    customValidation?: (value?: string) => Promise<ValidationResultType>;
};

const cleanValue = (value?: string): string => {
    const amountValue = value?.replace(/^(-)|[^0-9]+/g, '$1');
    if (!amountValue || amountValue === '') {
        return '';
    }
    const maxLength = 9;
    const sign = amountValue.startsWith('-') ? '-' : '';
    let amount = amountValue.replace(sign, '');

    if (amount.length > 0) {
        amount = '' + +amount;
    }
    if (amount.length > maxLength) {
        amount = amount.substring(0, maxLength);
    }

    return sign + amount;
};

const MonetaryField = (props: MonetaryFieldProps) => {
    const { customValidation, ...restProps } = props;

    return (
        <TextInputField
            type="tel"
            validation={{
                customValidation: props.customValidation,
            }}
            formatting={{ format: formatNumberByThousands, clean: cleanValue }}
            {...restProps}
        />
    );
};

export default MonetaryField;
